import { render } from "./AuthLoadingOverlay.vue?vue&type=template&id=2800c1c9&ts=true"
import script from "./AuthLoadingOverlay.vue?vue&type=script&lang=ts"
export * from "./AuthLoadingOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__